export enum SurecNoEnum {
    IslemYapilmamis = 1,
    OdemeIcinBekliyor = 2
}